import { NavLink } from 'react-router-dom'

import { MenuItem } from '@revolut-internal/ui-kit'

import { Route } from './routes'

export const MENU_ITEMS: MenuItem[] = [
  {
    id: Route.Monitoring,
    to: Route.Monitoring,
    title: 'Monitoring',
    icon: 'CandlestickChart',
    use: NavLink,
  },
]
